import { request } from '../http'

/**
 *  埋点上报
 */
export function eventlogAddData(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user-event-log/eventlog/addData', JSON.stringify(data))
  return methodInstance
}
